import { requiredString } from "../../utils/validations";
import { emailsValidation } from "./email";
export const validators = {
    name: (_template, value) => requiredString(value),
    // TODO: Find a way to validate filters
    // filters: (_template: BaseReportSchedule, value: DoNotCare) => filtersValidation(value),
    cadence: (_template, value) => requiredString(value),
    emails: (_template, value) => emailsValidation(value)
};
//# sourceMappingURL=validators.js.map